import axios from "axios";
import clientApi from "../api/client";
import apiUrl from './serveConfig';
import { parseQueryString } from "../utils/tools";
import UA from "../utils/ua";

/** 
* 调用方式：AXIOS.func({ data:{}, query:{} }, callback(res,err){ })
*/

let defaults = axios.create();

//接口默认域名端口
axios.defaults.baseURL = apiUrl;
// axios.defaults.baseURL = "https://api.aircourses.com"; 
// axios.defaults.baseURL = "http://47.111.78.238:8087";
// axios.defaults.baseURL = "http://192.168.10.209:18087";

//获取token
let token = '';
if (UA.ACClient) {
	token = JSON.parse(clientApi.getClientDataSync({ data: ["token"] })).token;
} else {
	token = "c7ea00dcd3534d3caaf8bba35e0f4e0b";
	// token = "1104c68178a0429d8e14c32482faab83"; 
}

axios.defaults.headers.common["access-token"] = token;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";

//接口地址列表
const API = {
	LOGIN: `/ac-common/oauth/sms/stu`, //登录
	GETINFO_BYID: `/ac-common/user-stu`, //学生信息
	STU_COURSE: `/ac-client/stu-course`, //学生课程列表
	GETLIST_GOODS: `/ac-client/goods-info`, //套餐列表
	GET_GOOD_INFO: `/ac-order/goods-info/detail`, // 单个套餐
	GETORDER_WEIXIN: `/ac-order/order-info`, //下单
	GETORDER_LIST: `/ac-order/order-info`, //订单列表列表
	GETORDER_STATUS: `/ac-order/order-info`, //查询订单
	PAY_WEIXIN: `/ac-order/wxpay`, //微信支付
	PAY_ALI: `/ac-order/alipay`, //支付宝支付
	STUHOMEWORK_SINGLE: `/ac-client/stu-work-detail/getByStuIdAndClassSchId`, //学生作业详情
	STUHOMEWORK_LIST: `/ac-client/stu-work-detail/listByStuId`, //学生作业列表
	PAY_TEST: `/ac-order/tmp/buy`, //支付测试
	WEIXIN_SHARE: `/ac-common/wx/getShareParam`, //获取微信配置
	DOWORK: `/ac-client/stu-work-detail/do`, //做作业
	WORKINFO: `/ac-client/class-sch/workInfo`, //获取作业列表
	WORKINFO_NEW: `/ac-client/class-sch/workInfo2`, //获取作业列表新
	ADD_ADDRESS: `/ac-common/user-address`, //新增用户地址
	GET_ADDRESS: `/ac-common/user-address/listByUserId`, //根据userid查询用户地址
	GET_LOGISTICS: `/ac-order/waybill-info/listByUserId`, //查询用户运单信息
	GET_COURSE_INFO: `/ac-client/course-info/stu/v2.0`, //查询课程信息
	GET_DISCOUNT_LIST: `/ac-client/coupon-info/listByGoodsId`, // 查询优惠券列表
	GOODS_INVITE_AWARD: `/ac-order/goods-invite-award`, // 套餐赠品
	HOMEWOER_SAVE: `/ac-client/stu-work-detail/do/save`, // 作业一题一保存
	HOMEWOER_END: `/ac-client/stu-work-detail/do/end`, // 作业结束
	HOMEWOER_DETAIL: `/ac-client/stu-work-detail/getWorkDetail`, // 获取作业进度
	HOMEWOER_BP: `/ac-client/bp/question-answer`, // 作业埋点（教研）
	FEED_BACK_LIST: `/ac-client/help-center/question/list`, // 帮助与反馈问题列表
	FEED_BACK_DETAIL: `/ac-client/help-center/question/detail`, // 帮助与反馈问题详情
	CUSTOMER_SERVICE_QRCODE: `/ac-client/help-center/customer-service/qr-code`, // 公众号二维码
};

//接口方法列表
const AXIOS = {
	login: (params, cb) => send(API.LOGIN, "POST", params, cb),
	getInfoById: (params, cb) => send(API.GETINFO_BYID, "GET", params, cb),
	getStuCourse: (params, cb) => send(API.STU_COURSE, "GET", params, cb),
	getGoodsInfo: (params, cb) => send(API.GETLIST_GOODS, "GET", params, cb),
	getGoodInfo: (params, cb) => send(API.GET_GOOD_INFO, "GET", params, cb),
	getWxOrder: (params, cb) => send(API.GETORDER_WEIXIN, "POST", params, cb),
	getOrderList: (params, cb) => send(API.GETORDER_LIST, "GET", params, cb),
	getOrderStatus: (params, cb) => send(API.GETORDER_STATUS, "GET", params, cb),
	payWeixin: (params, cb) => send(API.PAY_WEIXIN, "POST", params, cb, true),
	payAli: (params, cb) => send(API.PAY_ALI, "POST", params, cb, true),
	getStuHomeworkSingle: (params, cb) => send(API.STUHOMEWORK_SINGLE, "GET", params, cb),
	getStuHomeworkList: (params, cb) => send(API.STUHOMEWORK_LIST, "GET", params, cb),
	payTest: (params, cb) => send(API.PAY_TEST, "POST", params, cb),
	weixinShare: (params, cb) => send(API.WEIXIN_SHARE, "POST", params, cb),
	doWork: (params, cb) => send(API.DOWORK, "POST", params, cb),
	getWorkInfo: (params, cb) => send(API.WORKINFO, "GET", params, cb),
	getWorkInfoNew: (params, cb) => send(API.WORKINFO_NEW, "GET", params, cb),
	addAddress: (params, cb) => send(API.ADD_ADDRESS, "POST", params, cb),
	setAddress: (params, cb) => send(API.ADD_ADDRESS, "PUT", params, cb),
	getAddress: (params, cb) => send(API.GET_ADDRESS, "GET", params, cb),
	getLogistics: (params, cb) => send(API.GET_LOGISTICS, "GET", params, cb),
	getCourseInfo: (params, cb) => send(API.GET_COURSE_INFO, "GET", params, cb),
	getDiscountList: (params, cb) => send(API.GET_DISCOUNT_LIST, "GET", params, cb),
	getGoodsInviteAward: (params, cb) => send(API.GOODS_INVITE_AWARD, "GET", params, cb),
	homeworkSave: (params, cb) => send(API.HOMEWOER_SAVE, "POST", params, cb),
	homeworkEnd: (params, cb) => send(API.HOMEWOER_END, "POST", params, cb),
	homeworkDetail: (params, cb) => send(API.HOMEWOER_DETAIL, "GET", params, cb),
	homeworkBp: (params, cb) => send(API.HOMEWOER_BP, "POST", params, cb),
	getFeedBackList: (params, cb) => send(API.FEED_BACK_LIST, "GET", params, cb),
	getFeedBackDetail: (params, cb) => send(API.FEED_BACK_DETAIL, "GET", params, cb),
	getCsQrCode: (params, cb) => send(API.CUSTOMER_SERVICE_QRCODE, "GET", params, cb),
};

function send(api, method = "GET", params, cb) {
	const { query, data } = params;
	let url = "";
	if (params) {
		// query如果是string 直接拼在请求链接里
		if(typeof query === "string"){
			url = `/${query}`
		}
		// get方式 query转成参数拼在请求链接里
		if(method === 'GET'){
			url = `${url}${parseQueryString(data)}`
		}
	}
	let config = {
		method,
		withCredentials: true
	};
	if(method === "POST"){
		config.url = api;
		config.data = data;
	}
	else{
		if(method === "PUT"){
			config.data = data;
		}
		config.url = api + url;
	}
	defaults.request(config).then(res => {
		if (res.data.errorCode === 0) cb(res.data.data);
		else {
			cb(null, {
				errorCode: res.data.errorCode,
				errorMessage: res.data.errorMessage
			});
			clientApi.httpError({
				errorCode: res.data.errorCode,
				errorMessage: res.data.errorMessage
			});
		}
	}).catch(error => cb(null, error));
}
export default AXIOS;



// WEBPACK FOOTER //
// ./src/api/axios.js